import { render, staticRenderFns } from "./WelcomeMailContent.vue?vue&type=template&id=4f5674df"
import script from "./WelcomeMailContent.vue?vue&type=script&lang=js"
export * from "./WelcomeMailContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports